import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { enums } from "../../enums";
import Radio from "@material-ui/core/Radio";

const RadioButton = ({
  label,
  id,
  name,
  checked: buttonChecked,
  value,
  disabled,
  checkedState = "primary",
  labelPosition = "after",
  ...rest
}) => {
  const useStyles = makeStyles(() => ({
    root: {
      "&$checked": {
        color: checkedState === "primary" ? "#102E88" : "#27AE60",
      },
      "&&:hover": {
        backgroundColor: "transparent",
      },
    },
    checked: { color: "#102E88" },
  }));

  const { checked, root } = useStyles();

  return (
    <>
    {labelPosition === "before" && <label className="pm-label">{label}</label>}
      <Radio
        size="small"
        disableRipple
        classes={{ root, checked }}
        id={id}
        value={value}
        name={name}
        checked={buttonChecked}
        disabled={disabled}
        {...rest}
      />
      {labelPosition === "after" && <label className="pm-label">{label}</label>}
      
    </>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  checkedState: PropTypes.oneOf(enums.rad),
};

export default RadioButton;
